import {Component, Input} from '@angular/core';
import {MatButtonToggleChange} from '@angular/material/button-toggle';
import {DateSelectionFormGroup} from '@rsp/shared/component/date-selection/date-selection.form';
import {DateRange} from '@rsp/shared/util/util';
import {IntervalEnum} from '@rsp/models/enum/interval.enum';
import {UserTrackingService} from '@rsp/shared/services/user-tracking.service';


@Component({
  selector: 'rsp-date-selection',
  templateUrl: './date-selection.component.html',
  styleUrls: ['./date-selection.component.scss']
})
export class DateSelectionComponent {

  @Input() public formGroup: DateSelectionFormGroup;

  constructor(private userTracker: UserTrackingService) {
  }

  public compareDate = (o1: DateRange, o2: DateRange) => {
    return !!(o1 && o2 && o1.start && o1.end && o2.start && o2.end
      && o1.start.getTime() === o2.start.getTime() && o1.end.getTime() === o2.end.getTime());
  }

  public onChangeInterval(event: MatButtonToggleChange) {
    const value: IntervalEnum = event.value;
    this.userTracker.trackEvent('Diagramm', 'Datumsintervall', `auf ${value}`);
    this.formGroup.controls.interval.setValue(value);
  }

  public onChangeDate(event) {
    // this.trackDateSelection();
  }

  public onNavigate(dir: number) {
    this.trackDateSelection();
    const nextIndex = this.getSelectedDateIndex() + dir;
    this.formGroup.controls.date.setValue(this.formGroup.yearMonthOptions[nextIndex].value);
  }

  public hasNextOption(dir: number): boolean {
    const nextElement: number = this.getSelectedDateIndex() >= 0 ? this.getSelectedDateIndex() + dir : -1;
    return nextElement >= 0 && nextElement < this.formGroup.yearMonthOptions.length;
  }

  private getSelectedDateIndex(): number {
    const curSelected: DateRange = this.formGroup.selectedDate;

    return this.formGroup.yearMonthOptions.findIndex((option) => {
      return this.compareDate(curSelected, option.value);
    });
  }

  private trackDateSelection() {
    this.userTracker.trackEvent('Diagramm', 'Datumswechsel');
  }

}
